// import React, { useState } from "react";
// import styles from "./DeliveryPartnerTable.module.css";
// import { DeleteTo, ViewTo } from "../../icons/Icon3";
// import { Editwarehouse } from "../../icons/Icon4";
// import Button from "../Dealers/Button";
// import { AddIcon2 } from "../../icons/Icon";

// // ─── Status Badge ────────────────────────────────────────────────────────────
// const StatusBadge = ({ status }) => {
//   const s = String(status).toLowerCase();
//   const active = s === "active" || s === "1" || s === "online";
//   return (
//     <span
//       className={`${styles.badge} ${active ? styles.badgeActive : styles.badgeInactive}`}
//     >
//       <span className={styles.badgeDot} />
//       {active ? "Active" : "Inactive"}
//     </span>
//   );
// };

// // ─── Login Status Pill ───────────────────────────────────────────────────────
// const LoginPill = ({ status }) => {
//   const online = String(status).toLowerCase() === "online";
//   return (
//     <span
//       className={`${styles.loginPill} ${online ? styles.loginOnline : styles.loginOffline}`}
//     >
//       {online ? "Online" : "Offline"}
//     </span>
//   );
// };

// // ─── Avatar ──────────────────────────────────────────────────────────────────
// const Avatar = ({ name }) => {
//   const initials = name
//     ? name
//         .split(" ")
//         .map((w) => w[0])
//         .join("")
//         .slice(0, 2)
//         .toUpperCase()
//     : "?";
//   const hue =
//     [...(name || "")].reduce((acc, c) => acc + c.charCodeAt(0), 0) % 360;
//   return (
//     <span
//       className={styles.avatar}
//       style={{ background: `hsl(${hue},55%,42%)` }}
//     >
//       {initials}
//     </span>
//   );
// };

// // ─── Main Component ──────────────────────────────────────────────────────────
// const DeliveryPartnerTable = ({
//   allDelPartners = [],
//   loading = false,
//   mode = false, // false = light, true = dark
//   onView,
//   onEdit,
//   onDelete,
// }) => {
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [sortKey, setSortKey] = useState(null);
//   const [sortDir, setSortDir] = useState("asc");
//   const [search, setSearch] = useState("");

//   // ── Sort ─────────────────────────────────────────────────────────────────
//   const handleSort = (key) => {
//     if (sortKey === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
//     else {
//       setSortKey(key);
//       setSortDir("asc");
//     }
//   };

//   // ── Filter + Sort ─────────────────────────────────────────────────────────
//   const filtered = allDelPartners
//     .filter(
//       (p) =>
//         !search ||
//         p.partnerName?.toLowerCase().includes(search.toLowerCase()) ||
//         p.contactNumber?.toString().includes(search),
//     )
//     .sort((a, b) => {
//       if (!sortKey) return 0;
//       const va = String(a[sortKey] ?? "").toLowerCase();
//       const vb = String(b[sortKey] ?? "").toLowerCase();
//       return sortDir === "asc" ? va.localeCompare(vb) : vb.localeCompare(va);
//     });

//   // ── Columns ───────────────────────────────────────────────────────────────
//   const cols = [
//     { key: "partnerName", label: "Partner", sortable: true },
//     { key: "contactNumber", label: "Contact", sortable: true },
//     { key: "logInStatus", label: "Login", sortable: true },
//     { key: "partnerStatus", label: "Status", sortable: true },
//     { key: "actions", label: "Actions", sortable: false },
//   ];

//   const SortIcon = ({ col }) => {
//     if (!col.sortable) return null;
//     const active = sortKey === col.key;
//     return (
//       <span className={`${styles.sortIcon} ${active ? styles.sortActive : ""}`}>
//         {active && sortDir === "desc" ? "↓" : "↑"}
//       </span>
//     );
//   };

//   // ── Skeleton rows ─────────────────────────────────────────────────────────
//   if (loading) {
//     return (
//       <div className={`${styles.wrapper} ${mode ? styles.dark : styles.light}`}>
//         <div className={styles.tableHeader}>
//           <span className={styles.tableTitle}>Delivery Partners</span>
//         </div>
//         <div className={styles.tableWrap}>
//           <table className={styles.table}>
//             <thead>
//               <tr>
//                 {cols.map((c) => (
//                   <th key={c.key} className={styles.th}>
//                     {c.label}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {Array.from({ length: 5 }).map((_, i) => (
//                 <tr key={i} className={styles.skeletonRow}>
//                   {cols.map((c) => (
//                     <td key={c.key} className={styles.td}>
//                       <span className={styles.skeletonCell} />
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className={`${styles.wrapper} ${mode ? styles.dark : styles.light}`}>
//       {/* ── Header bar ── */}
//       <div className={styles.tableHeader}>
//         <span className={styles.tableTitle}>
//           Delivery Partners
//           <span className={styles.countChip}>{filtered.length}</span>
//         </span>

//         <div className={styles.searchWrap}>
//           <svg className={styles.searchIcon} viewBox="0 0 20 20" fill="none">
//             <circle
//               cx="9"
//               cy="9"
//               r="6"
//               stroke="currentColor"
//               strokeWidth="1.6"
//             />
//             <path
//               d="M14 14l3 3"
//               stroke="currentColor"
//               strokeWidth="1.6"
//               strokeLinecap="round"
//             />
//           </svg>
//           <input
//             className={styles.searchInput}
//             placeholder="Search partner or contact…"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//           {search && (
//             <button className={styles.clearBtn} onClick={() => setSearch("")}>
//               ✕
//             </button>
//           )}
//         </div>

//         <div>
//           <Button
//             buttonText={"Add Delivery Partner"}
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#FFFFFF"}
//             buttonIcon={<AddIcon2 />}
//             buttonClick={() => console.log("Coming Soon...")}
//           />
//         </div>
//       </div>

//       {/* ── Table scroll area ── */}
//       <div className={styles.tableWrap}>
//         {filtered.length === 0 ? (
//           <div className={styles.emptyState}>
//             <svg viewBox="0 0 64 64" className={styles.emptyIcon}>
//               <circle
//                 cx="32"
//                 cy="32"
//                 r="28"
//                 strokeWidth="2"
//                 stroke="currentColor"
//                 fill="none"
//               />
//               <path
//                 d="M22 32h20M32 22v20"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//               />
//             </svg>
//             <p>No delivery partners found</p>
//             {search && (
//               <button className={styles.resetBtn} onClick={() => setSearch("")}>
//                 Clear search
//               </button>
//             )}
//           </div>
//         ) : (
//           <table className={styles.table}>
//             <thead>
//               <tr>
//                 <th className={`${styles.th} ${styles.thIdx}`}>#</th>
//                 {cols.map((col) => (
//                   <th
//                     key={col.key}
//                     className={`${styles.th} ${col.sortable ? styles.thSortable : ""} ${sortKey === col.key ? styles.thSorted : ""}`}
//                     onClick={() => col.sortable && handleSort(col.key)}
//                   >
//                     {col.label}
//                     <SortIcon col={col} />
//                   </th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((item, i) => (
//                 <tr
//                   key={i}
//                   className={`${styles.tr} ${hoveredRow === i ? styles.trHover : ""}`}
//                   onMouseEnter={() => setHoveredRow(i)}
//                   onMouseLeave={() => setHoveredRow(null)}
//                 >
//                   {/* Index */}
//                   <td className={`${styles.td} ${styles.tdIdx}`}>{i + 1}</td>

//                   {/* Partner Name */}
//                   <td className={styles.td}>
//                     <div className={styles.nameCell}>
//                       <Avatar name={item.partnerName} />
//                       <span className={styles.partnerName}>
//                         {item.partnerName || "—"}
//                       </span>
//                     </div>
//                   </td>

//                   {/* Contact */}
//                   <td className={styles.td}>
//                     <span className={styles.contact}>
//                       {item.contactNumber || "—"}
//                     </span>
//                   </td>

//                   {/* Login Status */}
//                   <td className={styles.td}>
//                     <LoginPill status={item.logInStatus} />
//                   </td>

//                   {/* Partner Status */}
//                   <td className={styles.td}>
//                     <StatusBadge status={item.partnerStatus} />
//                   </td>

//                   {/* Actions */}
//                   <td className={styles.td}>
//                     <div className={styles.actions}>
//                       <button
//                         className={`${styles.actionBtn} ${styles.viewBtn}`}
//                         title="View"
//                         onClick={() => onView?.(item)}
//                       >
//                         <ViewTo mode={mode} />
//                       </button>
//                       <button
//                         className={`${styles.actionBtn} ${styles.editBtn}`}
//                         title="Edit"
//                         onClick={() => onEdit?.(item)}
//                       >
//                         <Editwarehouse mode={mode} />
//                       </button>
//                       <button
//                         className={`${styles.actionBtn} ${styles.deleteBtn}`}
//                         title="Delete"
//                         onClick={() => onDelete?.(item)}
//                       >
//                         <DeleteTo mode={mode} />
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {/* ── Footer ── */}
//       {/* {filtered.length > 0 && (
//         <div className={styles.footer}>
//           Showing <strong>{filtered.length}</strong> of{" "}
//           <strong>{allDelPartners.length}</strong> partners
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default DeliveryPartnerTable;

import React, { useMemo, useState } from "react";
import styles from "./DeliveryPartnerTable.module.css";
import { DeleteTo, ViewTo } from "../../icons/Icon3";
import { Editwarehouse } from "../../icons/Icon4";
import Button from "../Dealers/Button";
import { AddIcon2 } from "../../icons/Icon";
import { useNavigate } from "react-router-dom";

// ─── Status Badge ────────────────────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const s = String(status).toLowerCase();
  const active = s === "active" || s === "1" || s === "online";

  return (
    <span
      className={`${styles.badge} ${
        active ? styles.badgeActive : styles.badgeInactive
      }`}
    >
      <span className={styles.badgeDot} />
      {active ? "Active" : "Inactive"}
    </span>
  );
};

// ─── Login Status Pill ───────────────────────────────────────────────────────
const LoginPill = ({ status }) => {
  const online = String(status).toLowerCase() === "online";

  return (
    <span
      className={`${styles.loginPill} ${
        online ? styles.loginOnline : styles.loginOffline
      }`}
    >
      {online ? "Online" : "Offline"}
    </span>
  );
};

// ─── Avatar ──────────────────────────────────────────────────────────────────
const Avatar = ({ name }) => {
  const initials = name
    ? name
        .split(" ")
        .map((w) => w[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "?";

  const hue =
    [...(name || "")].reduce((acc, c) => acc + c.charCodeAt(0), 0) % 360;

  return (
    <span
      className={styles.avatar}
      style={{ background: `hsl(${hue},55%,42%)` }}
    >
      {initials}
    </span>
  );
};

// ─── Main Component ──────────────────────────────────────────────────────────
const DeliveryPartnerTable = ({
  allDelPartners = [],
  loading = false,
  mode = false,
  onView,
  onEdit,
  onDelete,
}) => {
  const navigate = useNavigate();
  const [hoveredRow, setHoveredRow] = useState(null);
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState("asc");
  const [search, setSearch] = useState("");

  // ── Sort ─────────────────────────────────────────────────────────────────
  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setSortDir("asc");
    }
  };

  // ── Filter + Sort ────────────────────────────────────────────────────────
  const filtered = useMemo(() => {
    return [...allDelPartners]
      .filter(
        (p) =>
          !search ||
          p.partnerName?.toLowerCase().includes(search.toLowerCase()) ||
          p.contactNumber?.toString().includes(search),
      )
      .sort((a, b) => {
        if (!sortKey) return 0;

        const va = String(a[sortKey] ?? "").toLowerCase();
        const vb = String(b[sortKey] ?? "").toLowerCase();

        return sortDir === "asc" ? va.localeCompare(vb) : vb.localeCompare(va);
      });
  }, [allDelPartners, search, sortKey, sortDir]);

  // ── Columns ──────────────────────────────────────────────────────────────
  const cols = [
    { key: "partnerName", label: "Partner", sortable: true },
    { key: "contactNumber", label: "Contact", sortable: true },
    { key: "logInStatus", label: "Login", sortable: true },
    { key: "partnerStatus", label: "Status", sortable: true },
    { key: "actions", label: "Actions", sortable: false },
  ];

  const SortIcon = ({ col }) => {
    if (!col.sortable) return null;

    const active = sortKey === col.key;

    return (
      <span className={`${styles.sortIcon} ${active ? styles.sortActive : ""}`}>
        {active && sortDir === "desc" ? "↓" : "↑"}
      </span>
    );
  };

  // ── Loading ──────────────────────────────────────────────────────────────
  if (loading) {
    return (
      <div className={`${styles.wrapper} ${mode ? styles.dark : styles.light}`}>
        <div className={styles.tableHeader}>
          <span className={styles.tableTitle}>Delivery Partners</span>
        </div>

        <div className={styles.listWrap}>
          <div className={styles.headerRow}>
            <div>#</div>
            <div>Partner</div>
            <div>Contact</div>
            <div>Login</div>
            <div>Status</div>
            <div>Actions</div>
          </div>

          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className={styles.skeletonRow}>
              {Array.from({ length: 6 }).map((__, idx) => (
                <span key={idx} className={styles.skeletonCell} />
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.wrapper} ${mode ? styles.dark : styles.light}`}>
      {/* ── Header ───────────────────────────────────────── */}
      <div className={styles.tableHeader}>
        <span className={styles.tableTitle}>
          Delivery Partners
          <span className={styles.countChip}>{filtered.length}</span>
        </span>

        <div className={styles.searchWrap}>
          <svg className={styles.searchIcon} viewBox="0 0 20 20" fill="none">
            <circle
              cx="9"
              cy="9"
              r="6"
              stroke="currentColor"
              strokeWidth="1.6"
            />
            <path
              d="M14 14l3 3"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
          </svg>

          <input
            className={styles.searchInput}
            placeholder="Search partner or contact…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          {search && (
            <button className={styles.clearBtn} onClick={() => setSearch("")}>
              ✕
            </button>
          )}
        </div>

        <div>
          <Button
            buttonText={"Add Delivery Partner"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#FFFFFF"}
            buttonIcon={<AddIcon2 />}
            // buttonClick={() => console.log("Coming Soon...")}
            buttonClick={() => navigate("/delivery/adddeliverypartner")}
          />
        </div>
      </div>

      {/* ── List ─────────────────────────────────────────── */}
      <div className={styles.listWrap}>
        {/* Header */}
        <div className={styles.headerRow}>
          <div className={styles.colIdx}>#</div>

          {cols.map((col) => (
            <div
              key={col.key}
              onClick={() => col.sortable && handleSort(col.key)}
              className={`${styles.headerCell} ${
                col.sortable ? styles.sortable : ""
              } ${sortKey === col.key ? styles.sorted : ""}`}
            >
              {col.label}
              <SortIcon col={col} />
            </div>
          ))}
        </div>

        {/* Empty */}
        {filtered.length === 0 ? (
          <div className={styles.emptyState}>
            <svg viewBox="0 0 64 64" className={styles.emptyIcon}>
              <circle
                cx="32"
                cy="32"
                r="28"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
              />
              <path
                d="M22 32h20M32 22v20"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>

            <p>No delivery partners found</p>

            {search && (
              <button className={styles.resetBtn} onClick={() => setSearch("")}>
                Clear search
              </button>
            )}
          </div>
        ) : (
          filtered.map((item, i) => (
            <div
              key={i}
              className={`${styles.row} ${
                hoveredRow === i ? styles.rowHover : ""
              }`}
              onMouseEnter={() => setHoveredRow(i)}
              onMouseLeave={() => setHoveredRow(null)}
            >
              {/* Index */}
              <div className={`${styles.cell} ${styles.colIdx}`}>{i + 1}</div>

              {/* Partner */}
              <div className={styles.cell}>
                <div className={styles.nameCell}>
                  <Avatar name={item.partnerName} />

                  <span className={styles.partnerName}>
                    {item.partnerName || "—"}
                  </span>
                </div>
              </div>

              {/* Contact */}
              <div className={styles.cell}>
                <span className={styles.contact}>
                  {item.contactNumber || "—"}
                </span>
              </div>

              {/* Login */}
              <div className={styles.cell}>
                <LoginPill status={item.logInStatus} />
              </div>

              {/* Status */}
              <div className={styles.cell}>
                <StatusBadge status={item.partnerStatus} />
              </div>

              {/* Actions */}
              <div className={styles.cell}>
                <div className={styles.actions}>
                  <button
                    className={`${styles.actionBtn} ${styles.viewBtn}`}
                    onClick={() => onView?.(item)}
                  >
                    <ViewTo mode={mode} />
                  </button>

                  <button
                    className={`${styles.actionBtn} ${styles.editBtn}`}
                    onClick={() => onEdit?.(item)}
                  >
                    <Editwarehouse mode={mode} />
                  </button>

                  <button
                    className={`${styles.actionBtn} ${styles.deleteBtn}`}
                    onClick={() => onDelete?.(item)}
                  >
                    <DeleteTo mode={mode} />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DeliveryPartnerTable;
